import { useRef } from 'react';

import { v4 as uuidv4 } from 'uuid';

/** Stable config-session widget id: layout `widgetId` when editing, else a one-off uuid for add flow. */
export const useResolveShellWidgetId = (layoutWidgetId?: string): string => {
  const shellWidgetIdRef = useRef<string | undefined>(undefined);

  if (shellWidgetIdRef.current === undefined) {
    shellWidgetIdRef.current = layoutWidgetId ?? uuidv4();
  }

  return shellWidgetIdRef.current;
};
